import { useEffect, useState } from 'react';
import { Stack, Text, Group } from '@mantine/core';
import { achievementsStore } from './achievementsStore';
import { ACHIEVEMENTS } from './achievements';
import { notifyAchievement } from './notifyAchievement';

// "My Achievements" — personal, no leaderboard. Locked ones stay a mystery (🔒 ???) to make
// discovery fun. Opening this screen is itself an achievement (Curious One).
export function AchievementsModal() {
    const [unlocked, setUnlocked] = useState(achievementsStore.getUnlocked());

    useEffect(() => {
        // Subscribe before unlocking: notifyAchievement dispatches the store event synchronously, so a
        // listener registered afterwards would miss the curious-one unlock. Refresh state after, too.
        const unsubscribe = achievementsStore.subscribe(() => setUnlocked(achievementsStore.getUnlocked()));
        notifyAchievement('curious-one');
        setUnlocked(achievementsStore.getUnlocked());
        return unsubscribe;
    }, []);

    return (
        <Stack gap="sm">
            <Text c="dimmed" size="sm">
                Unlocked {unlocked.length} / {ACHIEVEMENTS.length}
            </Text>
            {ACHIEVEMENTS.map((a) => {
                const has = unlocked.includes(a.id);
                return (
                    <Group key={a.id} wrap="nowrap" align="flex-start" gap="sm">
                        <Text fz={22} lh={1}>{has ? a.emoji : '🔒'}</Text>
                        <div>
                            <Text fw={600}>{has ? a.title : '???'}</Text>
                            <Text size="sm" c="dimmed">
                                {has ? a.desc : 'Locked — keep using the Backoffice.'}
                            </Text>
                        </div>
                    </Group>
                );
            })}
        </Stack>
    );
}
